export default function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-MQP2DV0VBW');
}
